import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Badge } from './ui/badge';
import { Keyboard } from 'lucide-react';

/**
 * KeyboardShortcutsHelp Component
 * Displays all available keyboard shortcuts
 */
const KeyboardShortcutsHelp = ({ isOpen, onClose, shortcuts }) => {
  const { language } = useLanguage();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Keyboard className="w-5 h-5" />
            {language === 'es' ? 'Atajos de Teclado' : 'Keyboard Shortcuts'}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Info */}
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
            <p className="text-sm text-blue-800 dark:text-blue-200">
              {language === 'es' 
                ? 'Usa estos atajos para navegar rápidamente por la aplicación. Presiona ? para ver esta ayuda en cualquier momento.'
                : 'Use these shortcuts to quickly navigate the app. Press ? to show this help anytime.'}
            </p>
          </div>

          {/* Shortcuts list */}
          <div className="space-y-2">
            {shortcuts.map((shortcut, index) => (
              <div 
                key={index}
                className="flex items-center justify-between p-3 rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
              >
                <div className="flex-1">
                  <p className="font-medium text-slate-900 dark:text-slate-100">
                    {shortcut.name}
                  </p>
                  <p className="text-xs text-slate-600 dark:text-slate-400">
                    {shortcut.description}
                  </p>
                </div>
                <Badge variant="outline" className="font-mono text-xs">
                  {shortcut.key.split('+').map((part, i) => (
                    <span key={i}>
                      {i > 0 && <span className="mx-1">+</span>}
                      <kbd className="px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded">
                        {part.toUpperCase()}
                      </kbd>
                    </span>
                  ))}
                </Badge>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default KeyboardShortcutsHelp;
